import { cx } from "class-variance-authority";

import { IconSpec } from "../../componentTypes/icon";
import { Svg } from "../../utils/svgIcon";
import { Button, ButtonProps } from "../Button";

import * as theme from "./ButtonGroup.css";

interface ButtonGroupProps {
    buttonSpecs: ButtonSpec[];
}

interface ButtonSpec {
    id: string;
    label: string;
    type: ButtonProps["variant"];
    disabled?: boolean;
    danger?: boolean;
    loading?: boolean;
    ghost?: boolean;
    onClick: () => void;
    icon?: IconSpec;
}

function ButtonGroup({ buttonSpecs }: ButtonGroupProps) {
    if (!buttonSpecs?.length) {
        return null;
    }

    return (
        <>
            {buttonSpecs.map((button) => {
                // Filled buttons need a light icon, outlined ones keep the accent.
                const isFilled =
                    !button.ghost &&
                    (button.type === "primary" ||
                        button.type === "destructive");

                return (
                    <Button
                        key={button.id}
                        id={button.id}
                        variant={button.type}
                        onClick={button.onClick}
                        disabled={button.disabled}
                        className={theme.buttonFooter}
                        loading={button.loading}
                        ghost={button.ghost}
                        danger={button.danger}
                    >
                        {button.icon ? (
                            <Svg
                                className={cx(
                                    theme.icon,
                                    isFilled && theme.iconOnFill
                                )}
                                src={button.icon.svg}
                            />
                        ) : null}
                        {button.label}
                    </Button>
                );
            })}
        </>
    );
}

export { ButtonGroup };
export type { ButtonSpec, ButtonGroupProps };
